// A row's hover action that asks first (wp/ACTIONS, "visible controls"): the 28 px ghost icon
// button of `RowAction`, opening an AlertDialog that names what happens; the action runs only on
// the dialog's confirm button. Used where a row's end, archive, revoke, unlink or delete is one
// click away.
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@companyos/ui";
import { type ComponentProps, type ReactNode, useState } from "react";
import { RowAction } from "./settings/row-actions";

export function ConfirmRowAction({
  title,
  description,
  confirmLabel,
  cancelLabel = "Cancel",
  destructive = true,
  onConfirm,
  className,
  ...action
}: Omit<ComponentProps<typeof RowAction>, "onClick"> & {
  /** The dialog's question (`Archive “Travel”?`). */
  title: string;
  description?: ReactNode;
  /** The confirm button's text (`Archive`). */
  confirmLabel: string;
  cancelLabel?: string;
  /** A red confirm button and a red hover on the icon. */
  destructive?: boolean;
  onConfirm: () => void;
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <RowAction
        {...action}
        className={destructive ? `hover:text-danger-text ${className ?? ""}` : className}
        onClick={() => setOpen(true)}
      />
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{title}</AlertDialogTitle>
            {description ? <AlertDialogDescription>{description}</AlertDialogDescription> : null}
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>{cancelLabel}</AlertDialogCancel>
            <AlertDialogAction
              variant={destructive ? "destructive" : "default"}
              onClick={() => {
                setOpen(false);
                onConfirm();
              }}
            >
              {confirmLabel}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
